import { Injectable } from '@angular/core';
import { JoinStateDetails, JoinStateType } from '@app/app/shared/models';
import { ObservableResult } from '@app/app/shared/store';
import { JoinAction, JoinDataService, JoinTarget } from './join-data.service';

const NEXT_STATE: Record<JoinAction, JoinStateType> = {
  ENROL: 'ENROLLED',
  REGISTER: 'PENDING_APPROVAL',
  WITHDRAW: 'CAN_REGISTER',
  ACCEPT_SEAT: 'ENROLLED',
  DECLINE_SEAT: 'CAN_REGISTER',
  ACCEPT_INVITATION: 'ENROLLED',
  DECLINE_INVITATION: 'NO_ACCESS',
};

@Injectable()
export class MockJoinDataService implements JoinDataService {
  act(_target: JoinTarget, action: JoinAction): ObservableResult<JoinStateDetails> {
    return ObservableResult.ofSuccess({ state: NEXT_STATE[action] });
  }
}
